import { Learner } from '../Learner';

export class ExportParameters {
    exportFormat: string;
    streaming: boolean;
    companionApp: boolean;
    lrsApiUrl: string;
    learners: Learner[];
    emailText:  string;
    isEmailEditorOpen: boolean;
}